/**
 * [FW-4042] Grosir gabungan (combined wholesale) price helper — mirror of
 * server/helpers/wholesalePriceHelper.js. Keep in sync.
 */

export const MIN_COMBINED_THRESHOLD = 2;

const toInt = (value) => {
  const n = parseInt(value, 10);
  return Number.isFinite(n) ? n : 0;
};

const toNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

export function tierUnitPrice(tier) {
  if (!tier) return 0;
  return toNumber(tier.priceCompare) > 0 ? toNumber(tier.priceCompare) : toNumber(tier.price);
}

export function sumCartQuantity(items) {
  if (!Array.isArray(items)) return 0;
  return items.reduce((total, item) => {
    if (!item) return total;
    const qty = item.qty != null ? item.qty : item.quantity;
    return total + toInt(qty);
  }, 0);
}

export function isCombinedWholesaleEnabled(config) {
  if (!config || !config.combinedWholesale) return false;
  return toInt(config.combinedWholesaleThreshold) >= MIN_COMBINED_THRESHOLD;
}

export function combinedWholesaleUnitPrice({ whosaleData, base, cartTotalQty, threshold }) {
  const baseline = toNumber(base);
  const tiers = Array.isArray(whosaleData) ? whosaleData : [];
  const th = toInt(threshold);
  if (!tiers.length || th < MIN_COMBINED_THRESHOLD || toInt(cartTotalQty) < th) {
    return baseline;
  }
  const wholesale = tierUnitPrice(tiers[0]);
  return wholesale > 0 ? wholesale : baseline;
}

export default {
  MIN_COMBINED_THRESHOLD,
  tierUnitPrice,
  sumCartQuantity,
  isCombinedWholesaleEnabled,
  combinedWholesaleUnitPrice,
};
